import type * as ngCore from '@angular/core'

import * as routeBound from '../route-bound'

import * as evaluation from './evaluation'
import * as packages from './packages'
import * as resources from './resources'

export { evaluation, packages, resources }

/**
 * Provides Quiver deployment state in the active admin route scope.
 */
export function provideEntityCollections(): ngCore.Provider[] {
  return [
    packages.Api,
    routeBound.Registry.provideDestroyable(packages.Collection),
    resources.Api,
    routeBound.Registry.provideDestroyable(resources.Collection),
    routeBound.Registry.provideDestroyable(evaluation.Feature),
  ]
}
